var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 13,
    viewBox: "0 0 26 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8407 8.57026C22.0053 8.57026 22.9495 9.56187 22.9495 10.7851C22.9495 12.0083 22.0053 12.9999 20.8407 12.9999C19.6765 12.9986 18.7331 12.0077 18.7318 10.7851C18.7318 9.56187 19.676 8.57026 20.8407 8.57026Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08344 5.72669L3.43391 4.59985C3.51401 4.56251 3.58181 4.50103 3.62877 4.42328L5.66557 1.01328C6.0449 0.377244 6.71138 -0.00635101 7.42595 7.95965e-05H15.703C16.3492 -0.00198528 16.9594 0.312053 17.3539 0.849628L19.9732 4.45372C20.0318 4.53608 20.1148 4.59566 20.2092 4.62304L24.5869 5.8812C25.2121 6.06403 25.643 6.66414 25.6386 7.34572V9.02712C25.6386 9.86416 25.0157 10.5603 24.2187 10.5603H23.8373C23.7249 9.00482 22.5479 7.76861 21.0668 7.65056C19.4111 7.51858 17.967 8.82128 17.8413 10.5603H8.36195C8.24954 9.00482 7.07251 7.76867 5.59148 7.65056C3.93575 7.51858 2.49162 8.82128 2.36596 10.5603H1.66881C0.871729 10.5603 0.248835 9.86416 0.248835 9.02712V7.10773C0.244341 6.51505 0.570927 5.97465 1.08344 5.72669Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36287 8.57026C6.52754 8.57026 7.47168 9.56187 7.47168 10.7851C7.47168 12.0083 6.52754 12.9999 5.36292 12.9999C4.19881 12.9986 3.2554 12.0077 3.25406 10.7851C3.25406 9.56187 4.19825 8.57026 5.36287 8.57026Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/Transportation.b35703c8bacc7ee39eed31fc36ff5966.svg";
export { ForwardRef as ReactComponent };